(function () {
	var documentSelection		= $(document)
	,userNameSelection			= $('.userName')
	,mainMenu								= $('.main-menu')
	,welcomeTab							= documentSelection.find('#p-ui-tabs a[href="#p-welcome"]')
	,clientsTableTab				= documentSelection.find('#p-ui-tabs a[href="#p-clients-table"]')
	,viewClientTab					= documentSelection.find('#p-ui-tabs a[href="#p-view-client"]')
	,editClientTab					= documentSelection.find('#p-ui-tabs a[href="#p-edit-client"]')
	,addClientTab						= documentSelection.find('#p-ui-tabs a[href="#p-add-client"]')
	,properiesTableTab			= documentSelection.find('#p-ui-tabs a[href="#p-properies-table"]')
	,viewPropertyTab				= documentSelection.find('#p-ui-tabs a[href="#p-view-property"]')
	,editPropertyTab				= documentSelection.find('#p-ui-tabs a[href="#p-edit-property"]')
	,addPropertyTab					= documentSelection.find('#p-ui-tabs a[href="#p-add-property"]')
	,editLmakrTab					  = documentSelection.find('#p-ui-tabs a[href="#p-edit-lmakr-settings"]')
	,viewLMCSEventActionTab	= documentSelection.find('#p-ui-tabs a[href="#p-view-lmcs-event-action"]')
	,editLMCSEventActionTab	= documentSelection.find('#p-ui-tabs a[href="#p-edit-lmcs-event-action"]')
	,addLMCSEventActionTab	= documentSelection.find('#p-ui-tabs a[href="#p-add-lmcs-event-action"]')
	,clientListTable				= documentSelection.find('#clientListTable')
	,propertyListTable			= documentSelection.find('#propertyListTable')
	,LMCSActionEventTable		= documentSelection.find('#LMCSActionEventTable')
	,clientsDataTable,propertiesDataTable,LMCSEventActionDataTable,previousTab,clientID,clientName,propertyID,propertyName,actionID,actionName,user,login;

	var createCustomFieldInput = function (targetNode) {
		var fields = '<div class="new-custom-field row"><div class="form-group col-sm-5"><input type="text" name="CUSTOM_FIELD_KEY" class="custom-action-input" placeholder="Enter Custom Field Key"></div><div class="form-group col-sm-5"><input type="text" name="CUSTOM_FIELD_VALUE" class="custom-action-input" placeholder="Enter Custom Field Value"></div><div class="form-group col-sm-2"><button class="btn btn--action btn--round removeCustomField"><i class="fa fa-minus" aria-hidden="true"></i></button></div></div>';
		$(fields).hide().appendTo(targetNode).fadeIn(500);
	};

	var prefilledCustomFieldInput = function (key,val,targetNode) {
		var fields = '<div class="new-custom-field row"><div class="form-group col-sm-5"><input type="text" name="CUSTOM_FIELD_KEY" class="custom-action-input" placeholder="Enter Custom Field Key" value="' + key + '"></div><div class="form-group col-sm-5"><input type="text" name="CUSTOM_FIELD_VALUE" class="custom-action-input" placeholder="Enter Custom Field Value" value="' + val + '"></div><div class="form-group col-sm-2"><button class="btn btn--action btn--round removeCustomField"><i class="fa fa-minus" aria-hidden="true"></i></button></div></div>';
		$(fields).hide().appendTo(targetNode).fadeIn(500);
	};

	firebase.auth().onAuthStateChanged( (user) => {
		var isLoggedIn = auth.tool.checkUserAuthStatus();

		if (isLoggedIn) {
			fireman.tool.createUserIfDoesNotExist(user);
			rt.tool.menuUtils.loggedInMenu(mainMenu, user.displayName);
			userNameSelection.html(user.displayName);
			clientsTableTab.tab('show');
		} else {
			rt.tool.menuUtils.loggedOutMenu(mainMenu);
			userNameSelection.html('');
			welcomeTab.tab('show');
		}
	});

	documentSelection.on('click', '.loginBtn', function () {
		auth.tool.loginGoogle();
	});

	documentSelection.on('click', '.logoutBtn', function () {
		auth.tool.logout();
	});

	welcomeTab.on('shown.bs.tab', function (e) {
		// home tab
		console.log(e.target); // newly activated tab
		console.log(e.relatedTarget); // previous active tab
		previousTab = e.relatedTarget; // previous active tab
	});

	// Load Client Table
	clientsTableTab.on('shown.bs.tab', function (e) {
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		clientsDataTable = rt.tool.dataTables.createClientsTable(clientListTable);
	});

	// view client tab
	viewClientTab.on('shown.bs.tab', function (e) {
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}
		previousTab = e.relatedTarget; // previous active tab
	});

	// edit client tab
	editClientTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');

		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}
		formContainer.html('');
		//console.log(clientID);
		var clientinfo = fireman.tool.getClient(clientID);
		//console.log(clientinfo);
		//console.log(e.target); // newly activated tab
		//console.log(e.relatedTarget); // previous active tab
		previousTab = e.relatedTarget; // previous active tab

		rt.tool.formUtils.editClientForm(formContainer, clientinfo);
		$(document).find('.rt-client-phone').mask('(000) 000-0000');

	});

	// add client tab
	addClientTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');

		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		previousTab = e.relatedTarget; // previous active tab
		rt.tool.formUtils.newClientForm(formContainer);
		$(document).find('.rt-client-phone').mask('(000) 000-0000');
	}).on('hide.bs.tab', function () {
		// Reset Add Client Panel
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
		formContainer.html('');
	});

	properiesTableTab.on('shown.bs.tab', function (e) {
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		var clientinfo = fireman.tool.getClient(clientID);
    $('.txtClientName').html(clientinfo.client_name + ' - ');
		propertiesDataTable = rt.tool.dataTables.createPropertyTable(clientID, propertyListTable);
		previousTab = e.relatedTarget; // previous active tab
	});

	// view propery tab
	viewPropertyTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var propertyData,pre;

		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		previousTab		= e.relatedTarget; // previous active tab
		propertyData	= fireman.tool.viewProperty(clientID,propertyID);
		$('.txtPropertyName').html(propertyData.property_name);
		LMCSEventActionDataTable = rt.tool.dataTables.createLMDirectorActionsTable(clientID, propertyID, LMCSActionEventTable);
	}).on('hide.bs.tab', function () {
		// Reset Add Client Panel
		var targetPanel		= $(this).attr('href');
		$('.txtPropertyName').html('');
	});

	// edit propery tab
	editPropertyTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
    formContainer.html('');
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		//console.log(e.target); // newly activated tab
		//console.log(e.relatedTarget); // previous active tab
		//console.log(clientID);
		//console.log(propertyID);
		var propertyInfo = fireman.tool.viewProperty(clientID,propertyID);
		$(targetPanel).find('span.txtPropertyName').html(propertyInfo.property_name);
		var clientinfo = fireman.tool.getClient(clientID);
		$(targetPanel).find('span.txtClientName').html(clientinfo.client_name + ' - ');
		previousTab = e.relatedTarget; // previous active tab
		rt.tool.formUtils.editPropertyForm(formContainer,clientID,propertyID,propertyInfo);
	});

	editLmakrTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
    formContainer.html('');
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

	  previousTab = e.relatedTarget; // previous active tab
		var lmakrInfo = fireman.tool.viewLmakrSetting(clientID, propertyID, formContainer);

	});

	// add propery tab
	addPropertyTab.on('shown.bs.tab', function (e) {
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
    formContainer.html('');
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		previousTab = e.relatedTarget; // previous active tab
		rt.tool.formUtils.newPropertyForm(clientID, formContainer);
	}).on('hide.bs.tab', function () {
		// Reset Add Client Panel
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
		formContainer.html('');
	});

	// add Leadmakr Call Scheduler Event Action
	editLMCSEventActionTab.on('shown.bs.tab', function (e) {
		var targetPanel		= $(this).attr('href');
		var formContainer	= $(targetPanel).find('.form-container');
		var actionData		= fireman.tool.LeadMakr.director.viewAction(clientID,propertyID,actionID);
		var labelInput,custIDInput,isActiveInput,applyToInput,openningTimeInput,closingTimeInput,delayInput,applyHrsInput,currentApplyTo,currentIsActive,currentApplyHrs;

		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		previousTab				= e.relatedTarget; // previous active tab
		rt.tool.formUtils.editLMDirectorActionForm(formContainer);

		// Get the action data
		var action = fireman.tool.LeadMakr.director.viewAction(clientID,propertyID,actionID);

		/*
		 * Checked to see if action is active then set ui toggle buttons appropriately
		 */
		if (action.is_active) {
			documentSelection.find('input[name*="TOGGLE_ACTIVATE_ACTION"][value="true"]').parents('label').addClass('active');
			documentSelection.find('input[name*="TOGGLE_ACTIVATE_ACTION"][value="false"]').parents('label').removeClass('active');
		} else {
			documentSelection.find('input[name*="TOGGLE_ACTIVATE_ACTION"][value="false"]').parents('label').addClass('active');
			documentSelection.find('input[name*="TOGGLE_ACTIVATE_ACTION"][value="true"]').parents('label').removeClass('active');
		}

		/*
		 * Checked to see if global time bracket is active then set ui toggle buttons appropriately
		 */
		if (action.use_global_time_bracket) {
			documentSelection.find('input[name*="GLOBAL_TIME_BRACKET"][value="true"]').parents('label').addClass('active');
			documentSelection.find('input[name*="GLOBAL_TIME_BRACKET"][value="false"]').parents('label').removeClass('active');
		} else {
			documentSelection.find('input[name*="GLOBAL_TIME_BRACKET"][value="false"]').parents('label').addClass('active');
			documentSelection.find('input[name*="GLOBAL_TIME_BRACKET"][value="true"]').parents('label').removeClass('active');
		}

		/*
		 * Prefill form with selected action's data
		 */
		documentSelection.find('input[name*="GLOBAL_TIME_BRACKET_IS_ACTIVE"]').val(action.use_global_time_bracket);
		documentSelection.find('input[name*="ACTION_IS_ACTIVE"]').val(action.is_active);
		documentSelection.find('input[name*="ACTION_LABEL"]').val(action.action_label);
		documentSelection.find('input[name*="ACTION_ID"]').val(action.lm_action_id);
		documentSelection.find('input[name*="GLOBAL_MIN_TIME"]').val(action.global_min_time);
		documentSelection.find('input[name*="GLOBAL_MAX_TIME"]').val(action.global_max_time);
		documentSelection.find('input[name*="MINS_DELAY"]').val(action.mins_delay);

		//console.log(typeof action.custom_field_rules === 'undefined' ? 'yes' : 'no');

		if (typeof action.custom_field_rules !== 'undefined') {
			action.custom_field_rules.forEach( function(element, index) {
			/*
			 * Need to add a delete function for when a user clicks on delete button
			 */
				for(var prop in element) {
					if (element.hasOwnProperty(prop)) {
						prefilledCustomFieldInput(prop, element[prop], $('#custom-field-container'));
					}
				}

			});
			/*
			 * Clear the custom fields table for this action
			 */
			fireman.tool.LeadMakr.director.deleteActionCustomFields(clientID,propertyID,actionID);
		} else {
			console.log('no')
		}

	}).on('hide.bs.tab', function () {
		// Reset Add Client Panel
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
		formContainer.html('');
	});

	// add Leadmakr Call Scheduler Event Action
	addLMCSEventActionTab.on('shown.bs.tab', function (e) {
		var targetPanel		= $(this).attr('href');
		var formContainer	= $(targetPanel).find('.form-container');

		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}

		previousTab				= e.relatedTarget; // previous active tab
		rt.tool.formUtils.newLMDirectorActionForm(formContainer);
	}).on('hide.bs.tab', function () {
		// Reset Add Client Panel
		var targetPanel = $(this).attr('href');
		var formContainer = $(targetPanel).find('.form-container');
		formContainer.html('');
	});

	documentSelection.on('click', '.dtClientDetailsBtn', function (e) {
		clientID = $(this).data('client-id');
		editClientTab.tab('show');
	});

	documentSelection.on('click', '.dtClientPropertiesBtn', function (e) {
		clientID = $(this).data('client-id');
		properiesTableTab.tab('show');
	});

	documentSelection.on('click', '.dtClientDeleteBtn', function (e) {
		if (auth.tool.checkUserAuthStatus() === false) {
			return false;
		}
		clientID = $(this).data('client-id');
		fireman.tool.deleteClient(clientID);
	});

	documentSelection.on('click', '.dtClientSettingsBtn', function (e) {
		rt.tool.alertMessage('Ooops! These are not the droids your\'s looking for...', 'failed', $('.navbar'));
	});

	documentSelection.on('click', '.dtPropertyDetailsBtn', function (e) {
		propertyID = $(this).data('property-id');
		//viewPropertyTab.tab('show');
		editPropertyTab.tab('show');
	});

	documentSelection.on('click', '.dtPropertyEventActionsBtn', function (e) {
		propertyID = $(this).data('property-id');
		viewPropertyTab.tab('show');
	});

	documentSelection.on('click', '.dtPropertyLmakrSettingsBtn', function (e) {
		//rt.tool.alertMessage('Load Lmakr Settings', 'failed', $('.navbar'));
		propertyID = $(this).data('property-id');
		//viewLmakrTab.tab('show');
		editLmakrTab.tab('show');
	});

	documentSelection.on('click', '.dtPropertyDeleteBtn', function (e) {
		//rt.tool.alertMessage('Load Lmakr Settings', 'failed', $('.navbar'));
		propertyID = $(this).data('property-id');
		fireman.tool.deleteProperty(clientID, propertyID);

	});

	/*documentSelection.on('click', '.dtEventActionDetailsBtn', function (e) {
		rt.tool.alertMessage('Ooops! These are not the droids your\'s looking for...', 'failed', $('.navbar'));
	});*/

	documentSelection.on('click', '.dtEventActionDetailsBtn', function (e) {
		actionID = $(this).data('action-id');
		editLMCSEventActionTab.tab('show');
	});

	documentSelection.on('click', '.returnBtn', function (e) {
		$(previousTab).tab('show');
	});

	documentSelection.on('click', '.viewClientsBtn', function (e) {
		clientsTableTab.tab('show');
	});

	documentSelection.on('click', '.viewProperties', function (e) {
		properiesTableTab.tab('show');
	});

	documentSelection.on('click', '.addClientBtn', function (e) {
		addClientTab.tab('show');
	});

	documentSelection.on('click', '.addPropertyBtn', function (e) {
		addPropertyTab.tab('show');
	});

	documentSelection.on('click', '.addLMCSEventAction', function (e) {
		addLMCSEventActionTab.tab('show');
	});

	documentSelection.on('click', '#createClientBtn, #updateClientBtn', function (e) {
		var submitBtn			= rt.tool.buttons.busy('loading..', $(this));
		var newClientForm = $(document).find('#new_client_form');
		var inputs				= newClientForm.find('input');
		var client				= {};
		var isValid				= false;
		var clientContactInfo, input,inputName;

		clientContactInfo = client['contact_info'] = {};

		inputs.each(function () {
			input			= $(this);
			inputName	= $(this).attr('name');

			switch (inputName) {
				case 'rt-client-name':
					if (input.val().length > 3) {
						client['client_name'] = rt.tool.toProperCase(input.val());
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter the client\'s name.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-client-cust-id':
					if (input.val().length >= 3) {
						client['client_indentifer'] = input.val().toLowerCase();
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a custom id.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-client-address1':
					if (input.val().length >= 3) {
						clientContactInfo['address1'] = rt.tool.toProperCase(input.val());
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter an address for the client.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-client-address2':
					if (input.val().length >= 3) {
						clientContactInfo['address2'] = rt.tool.toProperCase(input.val());
						isValid = true;
					} else {
						clientContactInfo['address2'] = '';
					}
					break;
				case 'rt-client-city':
					if (input.val().length >= 3) {
						clientContactInfo['city'] = rt.tool.toProperCase(input.val());
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a city.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-client-state':
					if (input.val().length === 2) {
						clientContactInfo['state'] = input.val().toUpperCase();
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid state.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-client-zip':
					if (input.val().length === 5) {
						clientContactInfo['zip'] = input.val();
					} else {
						rt.tool.helperPopover('Please enter a valid state.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					}
					break;
				case 'rt-client-phone':
					if (input.val().length === 14) {
						clientContactInfo['tel'] = input.val();
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid telephone number.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
			}
		});

		if (isValid) {
			if($(this).attr('id')=='updateClientBtn'){
				fireman.tool.editClient(clientID,client);
			} else {
				fireman.tool.createNewClient(client);
			}

		} else {
			console.log('Client is invalid');
		}
	});

	documentSelection.on('click','#updateLmakrSettingsBtn', function(e){
		var submitBtn				= rt.tool.buttons.busy('loading..', $(this));
		var leadmakrSettingsForm	= $(document).find('#leadmakrSettings_form');
		var input,inputName;

		var inputs					= leadmakrSettingsForm.find('input');
		var lmakrInfo				= {director:true};
		var isValid					= true;
    console.log(inputs)
		inputs.each(function () {
			input		= $(this);
			inputName	= $(this).attr('name');

			switch (inputName) {
				case 'rt-campaign-id':
					if (input.val().length > 3) {
						lmakrInfo['campaign_id'] = input.val();
					} else {
						rt.tool.helperPopover('Please enter LeadMakr Campaign ID.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-instance-id':
					if (input.val().length >= 3) {
						lmakrInfo['instance_id'] = input.val();
					} else {
						rt.tool.helperPopover('Please enter Instance ID.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'rt-product-id':
							lmakrInfo['product_id'] = input.val();
					break;
				case 'rt-client-id':
							if (input.val().length > 3) {
								clientID = input.val();
							} else {
								rt.tool.alertMessage('Ooops! Look like something went wrong', 'failed', $('.navbar'));
								rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
								isValid = false;
							}
				  break;
				}
			});

		if (isValid) {
				fireman.tool.editLmakrSetting(propertyID,lmakrInfo);
		} else {
			console.log('Invalid Lmakr Settings');
		}
	});

	documentSelection.on('click', '#createPropertyBtn,#updatePropertyBtn', function (e) {
		var submitBtn				= rt.tool.buttons.busy('loading..', $(this));
		if($(this).attr('id')=='updatePropertyBtn'){
			var PropertyForm	= $(document).find('#edit_property_form');
		} else {
			var PropertyForm	= $(document).find('#new_property_form');
		}

		var inputs					= PropertyForm.find('input');
		var property				= {};
		var isValid					= true;
		var leadMakr, callScheduler, services, input, inputName, clientID;
		services							= property['services'] = {};
		services['google']		= true;
		services['leadmakr']	= true;

		inputs.each(function () {
			input			= $(this);
			inputName	= $(this).attr('name');

			switch (inputName) {
				case 'rt-property-name':
						if (input.val().length > 3) {
							property['property_name'] = input.val();
						} else {
							rt.tool.helperPopover('Please enter a property name.', input);
							rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
							isValid = false;
						}
					break;
				case 'rt-property-url':
						if (input.val().length > 3) {
							property['property_url'] = input.val();
						} else {
							rt.tool.helperPopover('Please enter a property URL.', input);
							rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
							isValid = false;
						}
					break;
				case 'rt-jornaya_campID':
							if (input.val().length > 3) {
								property['jornaya_campID'] = input.val();
							} else {
								rt.tool.helperPopover('Please enter a Jornaya Camp-ID.', input);
								rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
								isValid = false;
							}
						break;
				case 'rt-onereach-wcid':
							//if (input.val().length > 3) {
								property['onereach_wcid'] = input.val();
							//	isValid = true;
							/*} else {
								rt.tool.helperPopover('Please enter One Reach WebChat ID.', input);
								rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
								isValid = false;
							}*/
						break;
				case 'rt-client-id':
						if (input.val().length > 3) {
							clientID = input.val();
						} else {
							rt.tool.alertMessage('Ooops! Look like something went wrong', 'failed', $('.navbar'));
							rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
							isValid = false;
						}
					break;
			 case 'rt-property-id':
							if (input.val().length > 3) {
								propertyID = input.val();
							} else {
								rt.tool.alertMessage('Ooops! Look like something went wrong', 'failed', $('.navbar'));
								rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
								isValid = false;
							}
						break;
			}
		});
console.log(property);
console.log(isValid);
		if (isValid) {
			if($(this).attr('id')=='updatePropertyBtn'){
				console.log('going to update property');
				console.log(property);
				fireman.tool.editClientProperty(clientID, propertyID, property);
			} else {
				fireman.tool.createClientProperty(clientID, property);
			}

		}
	});

	documentSelection.on('click', '#updateLMDirectorAction', function (e) {
		var submitBtn						= rt.tool.buttons.busy('loading..', $(this))
		,directorActionPayload	= {}
		,customFieldRules				= {}
		,customFieldCount				= $('.new-custom-field').length
		,daySettingCount				= $('.day-setting').length
		,custFieldArr						= directorActionPayload['custom_field_rules'] = []
		,isValid								= false;

		$('.action-input').each(function () {
			var input = $(this)
			,inputVal = input.val();

			switch (input.attr('name')) {
				case 'ACTION_IS_ACTIVE':

					if (inputVal === 'true') {
						directorActionPayload['is_active'] = true;
					} else if (inputVal === 'false') {
						directorActionPayload['is_active'] = false;
					}
					break;
				case 'ACTION_LABEL':
					if (inputVal.length > 2) {
						directorActionPayload['action_label'] = inputVal;
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid action label.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'ACTION_ID':
					if (inputVal.length >= 4) {
						directorActionPayload['lm_action_id'] = inputVal;
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid LeadMakr Action ID.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'GLOBAL_TIME_BRACKET_IS_ACTIVE':
					if (inputVal === 'true') {
						directorActionPayload['use_global_time_bracket'] = true;
					} else if (inputVal === 'false') {
						directorActionPayload['use_global_time_bracket'] = false;
					}
					break;
				case 'GLOBAL_MIN_TIME':
					directorActionPayload['global_min_time'] = inputVal;
					break;
				case 'GLOBAL_MAX_TIME':
					directorActionPayload['global_max_time'] = inputVal;
					break;
				case 'MINS_DELAY':
					directorActionPayload['mins_delay'] = inputVal;
					break;
			}
		});

		if (customFieldCount > 0) {

			$('.new-custom-field').each(function () {
				var customFieldRow	= $(this)
				,customKey					= $(this).find('input[name*="CUSTOM_FIELD_KEY"]').val()
				,customVal					= $(this).find('input[name*="CUSTOM_FIELD_VALUE"]').val()
				,customFieldObj			= {};

				if ( !(customKey.length > 0) ) {
					rt.tool.helperPopover('Please enter the custom field key.', customFieldRow.find('input[name*="CUSTOM_FIELD_KEY"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}

				if ( !(customVal.length > 0) ) {
					rt.tool.helperPopover('Please enter the custom field value.', customFieldRow.find('input[name*="CUSTOM_FIELD_VALUE"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}

				if ( !(customKey.indexOf(' ') >= 0) ) {
					customFieldObj[customKey] = customVal;
					custFieldArr.push(customFieldObj);
					isValid = true;
				} else {
					rt.tool.helperPopover('Please remove any spaces from the custom key.', customFieldRow.find('input[name*="CUSTOM_FIELD_KEY"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}
			});
		}

		if (daySettingCount > 0) {

			$('.day-setting').each(function () {
				var dayField			= $(this).find('input[name*="DAY"]').val().toLowerCase();
				var isActive			= $(this).find('input[name*="IS_ACTIVE"]').val();
				var useGlobalTime	= $(this).find('input[name*="USE_GLOBAL_TIME_BRACKET"]').val();
				var custMinTime		= $(this).find('input[name*="DAY_CUSTOM_MIN_TIME"]').val();
				var custMaxTime		= $(this).find('input[name*="DAY_CUSTOM_MAX_TIME"]').val();
				var dayObj				= {};

				if (isActive === 'true') {
					dayObj['is_active'] = true;
				} else if (inputVal === 'false') {
					dayObj['is_active'] = false;
				}

				dayObj['use_global_time_bracket'] = useGlobalTime;
				dayObj['custom_min_time'] = custMinTime;
				dayObj['custom_max_time'] = custMaxTime;

				directorActionPayload[dayField] = dayObj;
			});
		}

		if (isValid) {
			fireman.tool.LeadMakr.director.updateAction(clientID, propertyID, actionID, directorActionPayload);
		}
	});

	documentSelection.on('click', '#createLMDirectorAction', function (e) {
		var submitBtn						= rt.tool.buttons.busy('loading..', $(this))
		,directorActionPayload	= {}
		,customFieldRules				= {}
		,customFieldCount				= $('.new-custom-field').length
		,daySettingCount				= $('.day-setting').length
		,custFieldArr						= directorActionPayload['custom_field_rules'] = []
		,isValid								= false;

		$('.action-input').each(function () {
			var input = $(this)
			,inputVal = input.val();

			switch (input.attr('name')) {
				case 'ACTION_IS_ACTIVE':
					if (inputVal === 'true') {
						directorActionPayload['is_active'] = true;
					} else if (inputVal === 'false') {
						directorActionPayload['is_active'] = false;
					}
					break;
				case 'ACTION_LABEL':
					if (inputVal.length > 2) {
						directorActionPayload['action_label'] = inputVal;
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid action label.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'ACTION_ID':
					if (inputVal.length >= 4) {
						directorActionPayload['lm_action_id'] = inputVal;
						isValid = true;
					} else {
						rt.tool.helperPopover('Please enter a valid LeadMakr Action ID.', input);
						rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
						isValid = false;
					}
					break;
				case 'GLOBAL_TIME_BRACKET_IS_ACTIVE':
					if (inputVal === 'true') {
						directorActionPayload['use_global_time_bracket'] = true;
					} else if (inputVal === 'false') {
						directorActionPayload['use_global_time_bracket'] = false;
					}
					break;
				case 'GLOBAL_MIN_TIME':
					directorActionPayload['global_min_time'] = inputVal;
					break;
				case 'GLOBAL_MAX_TIME':
					directorActionPayload['global_max_time'] = inputVal;
					break;
				case 'MINS_DELAY':
					directorActionPayload['mins_delay'] = inputVal;
					break;
			}
		});

		if (customFieldCount > 0) {

			$('.new-custom-field').each(function () {
				var customFieldRow	= $(this)
				,customKey					= $(this).find('input[name*="CUSTOM_FIELD_KEY"]').val()
				,customVal					= $(this).find('input[name*="CUSTOM_FIELD_VALUE"]').val()
				,customFieldObj			= {};

				if ( !(customKey.length > 0) ) {
					rt.tool.helperPopover('Please enter the custom field key.', customFieldRow.find('input[name*="CUSTOM_FIELD_KEY"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}

				if ( !(customVal.length > 0) ) {
					rt.tool.helperPopover('Please enter the custom field value.', customFieldRow.find('input[name*="CUSTOM_FIELD_VALUE"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}

				if ( !(customKey.indexOf(' ') >= 0) ) {
					customFieldObj[customKey] = customVal;
					custFieldArr.push(customFieldObj);
					isValid = true;
				} else {
					rt.tool.helperPopover('Please remove any spaces from the custom key.', customFieldRow.find('input[name*="CUSTOM_FIELD_KEY"]'));
					rt.tool.buttons.reset(submitBtn.txt,submitBtn.btn);
					isValid = false;
				}
			});
		}

		if (daySettingCount > 0) {

			$('.day-setting').each(function () {
				var dayField			= $(this).find('input[name*="DAY"]').val().toLowerCase();
				var isActive			= $(this).find('input[name*="IS_ACTIVE"]').val();
				var useGlobalTime	= $(this).find('input[name*="USE_GLOBAL_TIME_BRACKET"]').val();
				var custMinTime		= $(this).find('input[name*="DAY_CUSTOM_MIN_TIME"]').val();
				var custMaxTime		= $(this).find('input[name*="DAY_CUSTOM_MAX_TIME"]').val();
				var dayObj				= {};

				if (isActive === 'true') {
					dayObj['is_active'] = true;
				} else if (inputVal === 'false') {
					dayObj['is_active'] = false;
				}

				dayObj['use_global_time_bracket'] = useGlobalTime;
				dayObj['custom_min_time'] = custMinTime;
				dayObj['custom_max_time'] = custMaxTime;

				directorActionPayload[dayField] = dayObj;
			});
		}

		if (isValid) {
			fireman.tool.LeadMakr.director.createAction(clientID, propertyID, directorActionPayload);
		}
	});

	documentSelection.on('rt-clientAdded-success', function(e) {
		rt.tool.alertMessage('Successfully added client', 'success', $('.navbar'));

		setTimeout(function(){
			clientsTableTab.tab('show');
		}, 3000);
	});

	documentSelection.on('rt-clientEdited-success', function(e) {
		rt.tool.alertMessage('Successfully Updated client', 'success', $('.navbar'));

		setTimeout(function(){
			clientsTableTab.tab('show');
		}, 3000);
	});

	documentSelection.on('rt-lmakrSettingsEdited-success', function(e) {
		rt.tool.alertMessage('Successfully Updated LeadMakr Settings', 'success', $('.navbar'));

		setTimeout(function(){
			properiesTableTab.tab('show');
		}, 3000);
	});

	documentSelection.on('rt-propertyDelete-success', function(e) {
		rt.tool.alertMessage('Successfully Deleted Client Property', 'success', $('.navbar'));
		setTimeout(function(){
			//viewPropertyTab.tab('show');
		}, 3000);
	});




	documentSelection.on('rt-propertyCreated-success', function(e) {
		rt.tool.alertMessage('Successfully added property.', 'success', $('.navbar'));

		setTimeout(function(){
			properiesTableTab.tab('show');
		}, 3000);
	});
	documentSelection.on('rt-propertyEdited-success', function(e) {
		rt.tool.alertMessage('Successfully edited property.', 'success', $('.navbar'));

		setTimeout(function(){
			properiesTableTab.tab('show');
		}, 3000);
	});

	documentSelection.on('rt-eventActionCreated-success', function(e) {
		rt.tool.alertMessage('Successfully added Event Action.', 'success', $('.navbar'));

		setTimeout(function(){
			viewPropertyTab.tab('show');
		}, 3000);
	});

	documentSelection.on('rt-actionEdited-success', function(e) {
		rt.tool.alertMessage('Successfully updated action.', 'success', $('.navbar'));

		setTimeout(function(){
			viewPropertyTab.tab('show');
		}, 3000);
	});

	documentSelection.on('click', '#set-custom-field-btn', function (e) {
		createCustomFieldInput($('#custom-field-container'));
	});

	documentSelection.on('click', '#set-custom-days-btn', function (e) {
		$('.days-container').fadeToggle();
	});

	documentSelection.on('click', '.toggleTimeBracket', function (e) {
		var thisVal = $(this).find('input').val();

		if (thisVal === 'true') {
			$('input[name*="GLOBAL_TIME_BRACKET_IS_ACTIVE"]').val(true);
			$('input[name*="GLOBAL_MIN_TIME"]').prop('disabled', false);
			$('input[name*="GLOBAL_MAX_TIME"]').prop('disabled', false);
		} else {
			$('input[name*="GLOBAL_TIME_BRACKET_IS_ACTIVE"]').val(false);
			$('input[name*="GLOBAL_MIN_TIME"]').prop('disabled', true);
			$('input[name*="GLOBAL_MAX_TIME"]').prop('disabled', true);
		}
	});

	documentSelection.on('click', '.toggleActivateAction', function (e) {
		var $this		= $(this);
		var thisVal	= $this.find('input').val();

		if (thisVal === 'true') {

			documentSelection.find('input[name*="ACTION_IS_ACTIVE"]').val(true);
		} else {

			documentSelection.find('input[name*="ACTION_IS_ACTIVE"]').val(false);
		}
	});

	documentSelection.on('click', '.toggleDay', function (e) {
		var $this		= $(this);
		var thisVal	= $this.find('input').val();

		if (thisVal === 'true') {

			$this.parents('.daySetting').find('input[name*="IS_ACTIVE"]').val(true);
		} else {

			$this.parents('.daySetting').find('input[name*="IS_ACTIVE"]').val(false);
		}
	});

	documentSelection.on('click', '.toggleDayGlobalTime', function (e) {
		var $this		= $(this);
		var thisVal = $this.find('input').val();
		var globalMinTime = $('input[name*="GLOBAL_MIN_TIME"]').val();
		var globalMaxTime = $('input[name*="GLOBAL_MAX_TIME"]').val();

		if (thisVal === 'true') {

			$this.parents('.daySetting').find('input[name*="USE_GLOBAL_TIME_BRACKET"]').val(true);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MIN_TIME"]').prop('disabled', true);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MAX_TIME"]').prop('disabled', true);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MIN_TIME"]').val(globalMinTime);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MAX_TIME"]').val(globalMaxTime);
		} else {

			$this.parents('.daySetting').find('input[name*="USE_GLOBAL_TIME_BRACKET"]').val(false);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MIN_TIME"]').prop('disabled', false);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MAX_TIME"]').prop('disabled', false);
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MIN_TIME"]').val('09:00:00');
			$this.parents('.daySetting').find('input[name*="DAY_CUSTOM_MAX_TIME"]').val('19:00:00');
		}
	});

	documentSelection.on('click', '.removeCustomField', function (e) {
		$(this).parents('.new-custom-field').fadeOut(500, () => {
			$(this).parents('.new-custom-field').remove();
		});
	});

	documentSelection.tooltip({
		selector	: '[data-toggle="tooltip"]'
		,animation: true
		,trigger	: 'hover'
		,container: 'body'
	});
})();
